export default __webpack_public_path__ + "static/media/a-que-huele-el-arte-de-maria.8300d680.jpg";